import React from "react";

const SettlementTimeline = ({ settlement }) => {

    const timeline = [

        {
            title: "Settlement Created",
            date: settlement.createdAt,
        },

        {
            title: "Verified",
            date: settlement.verifiedAt,
        },

        {
            title: "Approved",
            date: settlement.approvedAt,
        },

        {
            title: "Transferred",
            date: settlement.transferredAt,
        },

        {
            title: "Completed",
            date: settlement.completedAt,
        },

    ];

    return (

        <div className="settlement-timeline">

            <h3>Settlement Timeline</h3>

            {

                timeline.map((step, index) => (

                    <div
                        className="timeline-item"
                        key={index}
                    >

                        <div className="timeline-dot"></div>

                        <div className="timeline-content">

                            <h4>{step.title}</h4>

                            <p>

                                {step.date
                                    ? new Date(step.date).toLocaleString()
                                    : "-"}

                            </p>

                        </div>

                    </div>

                ))

            }

        </div>

    );

};

export default SettlementTimeline;